var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusOfflineSolid = function SvgStatusOfflineSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l6.921 6.922q.074.093.167.167l6.912 6.911a1 1 0 0 0 1.414-1.414l-.675-.675a9 9 0 0 0-.668-11.982A1 1 0 1 0 14.95 5.05a7 7 0 0 1 .657 9.143l-1.435-1.435a5 5 0 0 0-.637-6.294 1 1 0 1 0-1.414 1.415c.924.923 1.12 2.3.587 3.415l-1.992-1.992-.018-.018zM3.237 8.187a1 1 0 1 0-1.932-.516c-.8 3-.025 6.336 2.33 8.693a1 1 0 0 0 1.415-1.415 7 7 0 0 1-1.813-6.762M7.4 11.5a1 1 0 1 0-1.731 1c.214.371.48.72.795 1.035a1 1 0 0 0 1.415-1.414q-.287-.288-.478-.622"
  })));
};
export default SvgStatusOfflineSolid;